"use client";

import type { SupStoredAction, SupStoredData } from "@/types";
import React, { createContext, type Dispatch, type PropsWithChildren, useContext, useReducer } from "react";

import { StoreDataInitial, StoreDataInit, StoreDataReducer } from "@/store/data";

const StoredDataContext = createContext<SupStoredData>({} as SupStoredData);

const StoredDataDispatchContext = createContext<Dispatch<SupStoredAction>>({} as Dispatch<SupStoredAction>);

export function StoreContext({ children }: PropsWithChildren) {
  const [state, dispatch] = useReducer(StoreDataReducer, StoreDataInitial, StoreDataInit);

  return (
    <StoredDataContext.Provider value={state}>
      <StoredDataDispatchContext.Provider value={dispatch}>{children}</StoredDataDispatchContext.Provider>
    </StoredDataContext.Provider>
  );
}

export function useStoredData() {
  return useContext(StoredDataContext);
}

export function useStoredDataDispatch() {
  return useContext(StoredDataDispatchContext);
}

// to simplify the import
export * from "@/store/utils";
